/* Local production-preparation candidate. Not loaded by the merchant theme.
 * This validates a deployment manifest; it does not authorize publication,
 * grant analytics consent, initialize Google, or enable diagnostic access. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (root) root.BhDeploymentScope = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var DRAFT_ID = '196364992838';
  function own(value, key) {
    if (!value || typeof value !== 'object') return undefined;
    var descriptor = Object.getOwnPropertyDescriptor(value, key);
    return descriptor && Object.prototype.hasOwnProperty.call(descriptor, 'value') ? descriptor.value : undefined;
  }
  function plain(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
    var prototype = Object.getPrototypeOf(value);
    return prototype === Object.prototype || prototype === null;
  }
  function themeId(value) {
    if (typeof value === 'number' && Number.isSafeInteger(value) && value > 0) return String(value);
    return typeof value === 'string' && /^[1-9][0-9]{0,15}$/.test(value) ? value : null;
  }
  function resolve(manifest, context) {
    try {
      if (!plain(manifest) || !plain(context) || own(manifest, 'enabled') !== true || own(manifest, 'schema') !== 1) return null;
      var mode = own(manifest, 'mode'), expected = themeId(own(manifest, 'themeId'));
      var actual = themeId(own(context, 'themeId')), role = own(context, 'role');
      var host = own(context, 'hostname');
      if (typeof host !== 'string' || !/^(www\.)?baroquehour\.com$/.test(host)) return null;
      if (!expected || expected !== actual) return null;
      if (mode === 'draft') {
        if (expected !== DRAFT_ID || role !== 'unpublished') return null;
        return Object.freeze({ mode: mode, themeId: expected, storageKey: 'bh-click-handoff:' + expected + ':v1', diagnosticsAllowed: true });
      }
      var release = own(manifest, 'release');
      if (mode !== 'production' || role !== 'main' || typeof release !== 'string' ||
          !/^BH-[A-Z0-9][A-Z0-9_-]{0,63}$/.test(release)) return null;
      // Different namespace and schema from the existing Draft records.
      return Object.freeze({ mode: mode, themeId: expected,
        storageKey: 'bh-click-handoff:production:' + expected + ':' + release + ':v2', diagnosticsAllowed: false });
    } catch (_) { return null; }
  }
  return { resolve: resolve };
});
